import { CSSProperties, ReactNode } from 'react'

import { cssColors } from 'shared/ui/utils/cssTokens'

import styles from './InfoTile.module.scss'

interface InfoTileProps {
  icon: ReactNode
  backgroundColor?: string
  color?: string
  title: string | ReactNode
  text: string | ReactNode
}

const StepBox: React.FC<InfoTileProps> = ({
  icon,
  title,
  text,
  backgroundColor = cssColors.brand.secondaryLight,
  color = cssColors.brand.secondary
}) => {
  return (
    <div className={styles.step}>
      <div
        className={styles.iconWrapper}
        style={
          {
            '--info-tile-background': backgroundColor,
            '--info-tile-color': color
          } as CSSProperties
        }
      >
        {icon}
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{text}</div>
    </div>
  )
}

export default StepBox
